import {Box, IconButton, Menu, MenuItem, Button} from "@mui/material";
import {useState} from "react";
import MenuIcon from "@mui/icons-material/Menu";

export default function MobileMenu() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <IconButton
        size="large"
        edge="end"
        color="inherit"
        aria-label="menu"
        onClick={handleClick}>
        <MenuIcon />
      </IconButton>
      <Menu
        id="mobile-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 1,
          sx: {
            padding: "8px 0",
            borderRadius: "12px",
            width: "200px",
          },
        }}>
        <MenuItem onClick={handleClose}>Features</MenuItem>
        <MenuItem onClick={handleClose}>Exams</MenuItem>
        <MenuItem onClick={handleClose}>Help</MenuItem>
        <MenuItem onClick={handleClose}>Pricing</MenuItem>
        <MenuItem onClick={handleClose}>Log in</MenuItem>
        <MenuItem
          onClick={handleClose}
          sx={{
            backgroundColor: "black",
            color: "white",
            margin: "8px 8px 0 8px",
            borderRadius: "8px",
            "&:hover": {
              backgroundColor: "#333",
            },
          }}>
          Sign up
        </MenuItem>
      </Menu>
    </Box>
  );
}
